import React from "react";
import Colors from "../../../../global/Colors";
import {styled, Typography} from "@mui/material";
import {Chip} from "@mui/material";
import {useNavigate} from "react-router-dom";

export default function CustomNavChip({path, title, color, active}) {
  const navigate = useNavigate();

  const selected = active;

  const CustomChip = styled(Chip)({
    color: selected ? Colors.white : Colors.black,
    backgroundColor: selected ? Colors.blue[3] : Colors.blue[2],
    borderColor: Colors.black,
    "&&:hover, &&:focus": {
      color: Colors.white,
      backgroundColor: selected ? Colors.blue[3] : Colors.blue[2],
      borderColor: selected ? Colors.blue[3] : Colors.blue[2],
    },
  });

  const handleNavigateTo = (path) => {
    navigate(`/${path}`);
  };

  let baseStyle = "p-2 mx-1 my-1 text-center rounded-lg shadow-lg ";

  return (
    <div
      onClick={() => handleNavigateTo(path)}
      style={{
        backgroundColor: selected ? Colors.blue[3] : Colors.blue[2],
        borderRadius: '35px',
      }}
    >
      <div style={{padding: '16px'}}>
        <Typography style={{
          color: selected ? Colors.white : Colors.black,
          fontWeight: '500',
          textAlign: 'center',
          fontSize: '12px',
        }}>
          {title}
        </Typography>
      </div>
    </div>
    // <CustomChip
    //   variant={selected ? "default" : "outlined"}
    //   label={title}
    //   className={baseStyle + (selected ? "active" : "")}
    //   onClick={() => handleNavigateTo(path)}
    //   sx={{height: '32px !important'}}
    // />
  );
}
